module.exports = __webpack_public_path__ + "svg/logback.0b5e30.svg";